import BaseAPI from '../BaseAPI.js'

export default class extends BaseAPI {
  _parentResources = ['trainer']
  _resource ='devices'
}
